module.exports = __webpack_public_path__ + "static/media/dog.8638ee11.svg";